import * as React from 'react';

import { ISelectOptions } from '../../interfaces';
import { SelectDropdown } from './SelectDropdown';

export interface IRegionFilterProps {
    onChange: (filterType, value) => void;
    className?: string;
    selectedValue?: string;
}

export interface IRegionFilterState {
    selectedValue: string;
}

export class RegionFilter extends React.PureComponent<IRegionFilterProps, IRegionFilterState> {
    constructor(props: IRegionFilterProps) {
        super(props);
        this.state = { selectedValue: props.selectedValue };
    }

    componentWillReceiveProps(nextProps: IRegionFilterProps) {
        if (nextProps.selectedValue !== this.state.selectedValue) {
            this.setState({
                selectedValue: nextProps.selectedValue
            });
        }
    }

    handleChange = (e) => {
        this.setState({
            selectedValue: e
        });
        this.props.onChange('regionFilter', e);
    }

    availableRegions: ISelectOptions[] = [{ label: 'All', value: 'All' },
    { label: 'DFW', value: 'DFW' }, { label: 'Arkansas', value: 'Arkansas' },
    { label: 'Houston', value: 'Houston' }];

    render() {
        return (
            <div className={this.props.className || `region-filter-inline`} key="Region"  >
                <SelectDropdown
                    menuItems={this.availableRegions}
                    onChange={this.handleChange}
                    placeholder="Region"
                    defaultValue={this.props.selectedValue}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/RegionFilter.tsx